import React from "react";
import styled from "./style.module.css";

const LineOrange = () => {
  return (
    <>
      <span className={styled.root}></span>
    </>
  );
};

export default LineOrange;
